import { Navigate, Outlet } from 'react-router-dom';
import PageContainer from '../../../components/common/PageContainer';
import { usePermission } from "../../../hooks/usePermissions";
import { Modules } from "../Roles/roles-utils";

const RolesPage = () => {
  const hasPermission = usePermission(Modules.role.accessKey);

  if (!hasPermission) return <Navigate to="/home" />;

  return (
    <>
      <PageContainer
        title='User Management'
        subTitle='Roles & Permission'
        showDate
      >
        <Outlet />
      </PageContainer>
    </>
  );
};

export default RolesPage;
